import React, { Component } from 'react'
import videoJs from '../../assets/js/video'
import MyTitle from '../myTitle'
import styleObj from './style.module.scss'

export default class Review extends Component {
  constructor (props) {
    super(props)
    this.state = {
      curIndex: 0,
    }
  }
  render () {
    let { curIndex } = this.state
    let { list } = this.props
    return (
      !!list &&
      !!list.length && (
        <div className={styleObj['review-wrap']}>
          <MyTitle mainTitle="精彩回顾" subTitle="REVIEW" />
          <div className={styleObj['content']}>
            <div className={styleObj['left']}>
              <iframe
                title={list[curIndex].title}
                frameBorder="0"
                src={videoJs(list[curIndex].url)}
                allowFullScreen={true}
                width="100%"
                height="100%"
              ></iframe>
            </div>
            <ul className={styleObj['right']}>
              {list.map((item, i) => (
                <li
                  className={`${styleObj['item-wrap']} ${i === this.state.curIndex ? styleObj['on'] : ''
                    }`}
                  key={i}
                  onClick={() => {
                    this.selectItem(i)
                  }}
                >
                  <div className={styleObj['cover']}>
                    <img
                      src={`//s2.jiguo.com/${item.pic}`}
                      alt=""
                    />
                  </div>
                  <div className={styleObj['intro']}>
                    <div className={styleObj['title']}>{item.title}</div>
                    <div className={styleObj['desc']}>{item.subTitle}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )
    )
  }
  selectItem (curIndex) {
    this.setState({ curIndex })
  }
}
